module.exports = __webpack_public_path__ + "static/media/pamain-bold.e1eafde1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-bold.woff2
// module id = ./src/assets/fonts/pamain-bold.woff2
// module chunks = 6